import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Button } from '../ui/button';
import { LucideIcon } from 'lucide-react';

interface KYCCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  status: 'pending' | 'completed';
  onVerify: () => void;
  bgColor: string;
  iconColor: string;
  iconSize?: string;
}

const KYCCard: React.FC<KYCCardProps> = ({
  icon: Icon,
  title,
  description,
  status,
  onVerify,
  bgColor,
  iconColor,
  iconSize = 'h-5 w-5',
}) => {
  return (
    <Card
      className={`${bgColor} max-w-xs mx-auto w-full flex flex-col min-h-[220px]`}
    >
      <CardHeader className="flex flex-row items-center gap-2 ">
        <div>
          {' '}
          <Icon className={`${iconSize} ${iconColor}`} />
        </div>

        <CardTitle className="text-sm">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col flex-grow h-[140px]">
        <p className="text-xs text-gray-600">{description}</p>
        <Button
          className={`w-full mt-auto ${
            status === 'completed'
              ? 'text-green-600 border-green-600 hover:bg-green-50'
              : ''
          }`}
          size="sm"
          variant={status === 'completed' ? 'outline' : 'default'}
          disabled={status === 'completed'}
          onClick={onVerify}
        >
          {status === 'completed' ? 'Completed' : 'Verify'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default KYCCard;
